import { AccountingErrorCode, AccountingErrorResponse } from 'multirpc-sdk';
import { AxiosError } from 'axios';

import { isAxiosAccountingError } from 'store/utils/isAxiosAccountingError';
import { getAccountingErrorCode } from 'store/utils/getAccountingErrorCode';

export const isTFARequiredError = (
  error: unknown,
): error is AxiosError<AccountingErrorResponse> =>
  isAxiosAccountingError(error) &&
  getAccountingErrorCode(error) === AccountingErrorCode.TwoFARequired;
